import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from './http.service';
import * as Global from '../global';
import FilterOptions from '../models/FilterOptions';
import PaginationOptions from '../models/PaginationOptions';

@Injectable({
  providedIn: 'root',
})
export class TripService {
  Global = Global;
  private refresh = new BehaviorSubject<boolean>(false);

  trips: any[] = [];
  paginationValue: PaginationOptions = Global.resetPaginationOptions();
  filterValue: FilterOptions = Global.resetTableFilterOptions();
  scrollPosition = 0;
  selectedId = null;
  constructor(private httpService: HttpService) { }
  deleteTrip(tripId: string) {
    // Find the index of the trip to delete
    const tripIndex = this.trips.findIndex((trip) => trip.id === tripId);

    // If the trip is found, remove it from the array
    if (tripIndex !== -1) {
      this.trips.splice(tripIndex, 1);
    } else {
      console.error(`Trip with id ${tripId} not found.`);
    }
  }
  updateTrip(tripId: string) {
    // Find the index of the trip to update
    const tripIndex = this.trips.findIndex((trip) => trip.id === tripId);

    // If the trip is found, update it
    if (tripIndex !== -1) {
      let params = new URLSearchParams();
      params.set('id', String(tripId));
      this.fetchTrips({ params }).subscribe({
        next: (res: any) => {
          const data = res?.data[0] ?? null;
          if (data) {
            // Update the trip with the fetched data
            this.trips[tripIndex] = { ...this.trips[tripIndex], ...data };
          } else {
            console.error('No data found for the trip.');
          }
        },
        error: (err: any) => {
          console.error('Error fetching trip data:', err);
        },
        complete: () => { },
      });
    } else {
      console.error(`Trip with id ${tripId} not found.`);
    }
  }
  setTrips(
    trips: any[],
    paginationValue: PaginationOptions,
    filterValue: FilterOptions
  ) {
    this.trips = trips;
    this.paginationValue = paginationValue;
    this.filterValue = filterValue;
  }
  getTrips() {
    return {
      trips: this.trips,
      paginationValue: this.paginationValue,
      filterValue: this.filterValue,
    };
  }
  setScrollPosition(scrollPosition: number) {
    this.scrollPosition = scrollPosition;
  }
  getScrollPostion() {
    return this.scrollPosition;
  }
  setSelectedId(id: any) {
    this.selectedId = id;
  }
  getSelectedId() {
    return this.selectedId;
  }
  clearData() {
    this.trips = [];
    this.selectedId = null;
    this.scrollPosition = 0;
    this.paginationValue = Global.resetPaginationOptions();
    this.filterValue = Global.resetTableFilterOptions();
  }
  updateRefresh(op: any) {
    this.refresh.next(op);
  }
  refreshData(): Observable<any> {
    return this.refresh.asObservable();
  }
  cancelPacificUser(payload: any) {
    return this.httpService.put('api/Trip/CancelPacificUser', payload);
  }
  cancelRequestTripItineraryHotel(payload: any) {
    return this.httpService.put(
      'api/Trip/CancelRequestTripItineraryHotel',
      payload
    );
  }
  updateItineraryHotelBookingQuotaion(payload: any) {
    return this.httpService.put(
      'api/Trip/UpdateItineraryHotelBookingQuotaion',
      payload
    );
  }
  addItineraryTicketBookingQuotaion(payload: any) {
    return this.httpService.post(
      'api/Trip/AddItineraryTicketBookingQuotaion',
      payload
    );
  }
  addItineraryHotelBookingQuotaion(payload: any) {
    return this.httpService.post(
      'api/Trip/AddItineraryHotelBookingQuotaion',
      payload
    );
  }
  UpdateItineraryTicketBookingQuotaionn(payload: any) {
    return this.httpService.put(
      'api/Trip/UpdateItineraryTicketBookingQuotaion',
      payload
    );
  }
  addQuotation(payload: any, isItinery: boolean = true) {
    if (isItinery) {
      return this.addItineraryTicketBookingQuotaion(payload);
    } else {
      return this.addItineraryHotelBookingQuotaion(payload);
    }
  }
  addRMQuotationNotes(payload: any, isItinery: boolean = true) {
    if (isItinery) {
      return this.UpdateItineraryTicketBookingQuotaionn(payload);
    } else {
      return this.updateItineraryHotelBookingQuotaion(payload);
    }
  }
  deleteQuotation(Id: string, isItinerary: boolean) {
    if (isItinerary) {
      return this.httpService.delete(
        'api/Trip/DeleteItineraryTicketBookingQuotation/' + Id
      );
    } else {
      return this.httpService.delete(
        'api/Trip/DeleteItineraryHotelBookingQuotation/' + Id
      );
    }
  }
  UpdateAllTripItineraryBookStatus(payload: any) {
    return this.httpService.put(
      'api/Trip/UpdateAllTripItineraryBookStatus',
      payload
    );
  }
  GetAdvanceMoney(payload: any) {
    return this.httpService.getList('api/Trip/GetAdvanceMoney', payload);
  }
  TripRequestAdvanceMoneyApproval(payload: any) {
    return this.httpService.put(
      'api/Trip/TripRequestAdvanceMoneyApproval',
      payload
    );
  }
  addTripItinerary(payload: any) {
    if (!payload?.id) {
      return this.httpService.post('api/Trip/AddTripItinerary', {
        tripItinerary: [payload],
      });
    } else {
      return this.httpService.put('api/Trip/UpdateTripItinerary', {
        tripItinerary: [payload],
      });
    }
  }
  addTripHotelBooking(payload: any) {
    if (!payload?.id) {
      return this.httpService.post('api/Trip/AddTripHotelBooking', {
        tripHotelBooking: [payload],
      });
    } else {
      return this.httpService.put('api/Trip/UpdateTripHotelBooking', {
        tripHotelBooking: [payload],
      });
    }
  }
  deleteItinerary(id: string) {
    return this.httpService.delete('api/Trip/DeleteTripItinerary/' + id);
  }
  deleteTripHotelBooking(id: string) {
    return this.httpService.delete('api/Trip/DeleteTripHotelBooking/' + id);
  }
  fetchTrips(payload: any) {
    return this.httpService.getList('api/Trip', payload);
  }
  UpdateAllTripItineraryBookStatusForDirector(payload: any) {
    return this.httpService.put(
      'api/Trip/UpdateAllTripItineraryBookStatusForDirector',
      payload
    );
  }
  submitTripBasicData(payload: any) {
    if (payload?.id) {
      return this.httpService.put('api/Trip', payload);
    } else {
      return this.httpService.post('api/Trip', payload);
    }
  }
  fetchAllPurpose(payload: any) {
    return this.httpService.get('api/Trip/GetAllPurpose', payload);
  }
  getTripItinerary(payload: any) {
    return this.httpService.getList('api/Trip/GetAllTripItinerary', payload);
  }
  getTripHotelBooking(payload: any) {
    return this.httpService.getList('api/Trip/GetAllTripHotelBooking', payload);
  }
  addTravelDeskExpense(payload: any) {
    return this.httpService.put(
      'api/Trip/UpdateTripItineraryBookStatus',
      payload
    );
  }
  updateTripStatus(payload: any) {
    return this.httpService.put('api/Trip/UpdateTripStatus', payload);
  }
  updateStatusTripRequestAdvanceMoney(payload: any) {
    return this.httpService.put(
      'api/Trip/UpdateStatusTripRequestAdvanceMoney',
      payload
    );
  }
  fetchTripTrackings(payload: any) {
    return this.httpService.getList('api/Trip/GetTripTrackings', payload);
  }
  addTripRemarks(payload: any) {
    return this.httpService.post('api/Trip/AddTripTracking', payload);
  }
  updateTripItineraryBookStatus(payload: any) {
    return this.httpService.put(
      'api/Trip/UpdateTripItineraryBookStatus',
      payload
    );
  }
  addItineraryTicketBooking(payload: any) {
    return this.httpService.post('api/Trip/AddItineraryTicketBooking', payload);
  }
  rescheduleTripItineraryHotel(payload: any) {
    return this.httpService.put(
      'api/Trip/RescheduleTripItineraryHotel',
      payload
    );
  }
  updateItineraryTicketBooking(payload: any) {
    return this.httpService.put(
      'api/Trip/UpdateItineraryTicketBooking',
      payload
    );
  }
  deleteItineraryTicketBooking(id: string) {
    return this.httpService.delete(
      'api/Trip/DeleteItineraryTicketBooking/' + id
    );
  }
  requestAdvance(payload: any) {
    return this.httpService.put(
      'api/Trip/UpdateTripRequestAdvanceMoney',
      payload
    );
  }
  deleteTripById(id: string) {
    return this.httpService.delete('api/Trip/' + id);
  }
  addTripItineraryBulk(payload: any, addItem: any) {
    if (addItem) {
      return this.httpService.post('api/Trip/AddTripItinerary', payload);
    } else {
      return this.httpService.put('api/Trip/UpdateTripItinerary', payload);
    }
  }
  addTripHotelBookingBulk(payload: any, addItem: any) {
    if (addItem) {
      return this.httpService.post('api/Trip/AddTripHotelBooking', payload);
    } else {
      return this.httpService.put('api/Trip/UpdateTripHotelBooking', payload);
    }
  }
}
